var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 15,
    fill: "#F11A7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 34H17.4766V21.3203H20.875V34ZM17.2773 18.0391C17.2773 17.5312 17.4453 17.1133 17.7812 16.7852C18.125 16.457 18.5898 16.293 19.1758 16.293C19.7539 16.293 20.2148 16.457 20.5586 16.7852C20.9023 17.1133 21.0742 17.5312 21.0742 18.0391C21.0742 18.5547 20.8984 18.9766 20.5469 19.3047C20.2031 19.6328 19.7461 19.7969 19.1758 19.7969C18.6055 19.7969 18.1445 19.6328 17.793 19.3047C17.4492 18.9766 17.2773 18.5547 17.2773 18.0391ZM27.273 21.3203L27.3784 22.7852C28.2847 21.6523 29.4995 21.0859 31.023 21.0859C32.3667 21.0859 33.3667 21.4805 34.023 22.2695C34.6792 23.0586 35.0152 24.2383 35.0308 25.8086V34H31.6441V25.8906C31.6441 25.1719 31.4878 24.6523 31.1753 24.332C30.8628 24.0039 30.3433 23.8398 29.6167 23.8398C28.6636 23.8398 27.9488 24.2461 27.4722 25.0586V34H24.0855V21.3203H27.273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3be789ed34cf4b4e0cf17dddcb2f85ab.svg";
export { ForwardRef as ReactComponent };